// extracted by mini-css-extract-plugin
export default {"container":"UMkX8l5CaV9qREcWf7Ae","prevNextButton":"UMyKIY9c4DjSVqe6Ubft","items":"WIwBVT9TCPsIsRdnq0No"};